import StudioMainSection from "@/v2-components/pages/software/components/studio/studio-main-section";
import { StudioMainInfo } from "@/v2-components/pages/software/components/studio/studio-main-info";
import StudioFeatures from "@/v2-components/pages/software/components/studio/studio-features";
import { useTrans } from "@/utils/useTrans";
import { SoftwareMainImgSection } from "@/v2-components/pages/software/components/software-main-img-section";
import { SoftwareMainContents } from "@/v2-components/pages/software/components/software-main-contents";
import SoftwarePageTemplate from "@/components/templates/SoftwarePageTemplate";
import { getSoftwareServerSideProps } from "@/libs/getSoftwareServerSideProps";
import { GetServerSidePropsContext } from "next";

const MAIN_IMG = "/images/software/studio/software_studio_title.jpg";
const MAIN_ING_MOBILE =
  "/images/software/studio/software_studio_title_mobile.jpg";

const StudioPage = ({ countryCode }: { countryCode: string }) => {
  const { t } = useTrans(["software"]);

  const info = {
    head: t("bHaptics Studio"),
    body: t(
      "Use bHaptics Studio to configure audio-based haptic frequency settings and create your own audio-based haptic profiles.",
    ),
  };

  return (
    <SoftwarePageTemplate>
      <SoftwarePageTemplate.Content countryCode={countryCode}>
        <div className="relative flex w-full flex-col gap-10 bg-white md:gap-16">
          <SoftwareMainImgSection
            bgImg={MAIN_IMG}
            bgMobileImg={MAIN_ING_MOBILE}
            contents={<SoftwareMainContents info={info} />}
          />
          <section className="flex flex-col gap-10">
            <StudioMainSection contents={<StudioMainInfo />} />
            <StudioFeatures />
          </section>
        </div>
      </SoftwarePageTemplate.Content>
    </SoftwarePageTemplate>
  );
};

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  return getSoftwareServerSideProps(ctx);
}

export default StudioPage;
